import * as actions from './leads/actions'
import * as mutations from './leads/mutations'
import * as getters from './leads/getters'

import { dataProps } from './leads/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps)),
    search_type: -1,
    search_term: ''
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/leads.js